import { useTranslation } from "../../core/translation.core";
import { ShopUserType } from "../../types/shop";
import { AdminUserStatus } from "../../types/user";

export function UserStatus({ status }: { status: AdminUserStatus }) {
  const { t, msg } = useTranslation();

  switch (status) {
    case AdminUserStatus.created:
      return <>{t(msg.user.statusCreated)}</>;
    case AdminUserStatus.pending:
      return <>{t(msg.user.statusPending)}</>;
    default:
      return <></>;
  }
}

export function UserType({ type }: { type: ShopUserType }) {
  const { t, msg } = useTranslation();

  switch (type) {
    case ShopUserType.admin:
      return <>{t(msg.user.typeAdmin)}</>;
    case ShopUserType.shopManager:
      return <>{t(msg.user.typeShopManager)}</>;
    case ShopUserType.retail:
      return <>{t(msg.user.typeRetail)}</>;
    default:
      return <></>;
  }
}
